import type { Address } from '@app/packages/geo/Address'
import type { MapBounds } from '@app/packages/geo/MapBounds'
import { clampLatitude } from '@app/packages/geo/Point'

export function extrudeBounds(bounds: MapBounds, factor: number) {
  const cloned: MapBounds = [[...bounds[0]], [...bounds[1]]]
  const mw = Math.abs(cloned[1][0] - cloned[0][0])
  const mh = Math.abs(cloned[1][1] - cloned[0][1])
  cloned[0][0] -= mw * factor
  cloned[0][1] -= mh * factor
  cloned[1][0] += mw * factor
  cloned[1][1] += mh * factor
  return cloned
}

/** The address's own box, or 0.1° around its point, which near a pole would otherwise pass ±90. */
export function addressMapBounds(address?: Address): MapBounds | undefined {
  if (!address) return undefined
  if (address.bounds)
    return [
      [address.bounds.bottomLeft.lat, address.bounds.bottomLeft.lon],
      [address.bounds.topRight.lat, address.bounds.topRight.lon],
    ]
  return [
    [clampLatitude(address.location.lat - 0.1), address.location.lon - 0.1],
    [clampLatitude(address.location.lat + 0.1), address.location.lon + 0.1],
  ]
}
